// Wine rating score thresholds
export const SCORE_THRESHOLDS = {
  EXCEPTIONAL: 95,
  OUTSTANDING: 90,
  VERY_GOOD: 85,
  GOOD: 80,
  AVERAGE: 70,
};

// Score labels
export const SCORE_LABELS = {
  [SCORE_THRESHOLDS.EXCEPTIONAL]: 'Exceptional',
  [SCORE_THRESHOLDS.OUTSTANDING]: 'Outstanding',
  [SCORE_THRESHOLDS.VERY_GOOD]: 'Very Good',
  [SCORE_THRESHOLDS.GOOD]: 'Good',
  [SCORE_THRESHOLDS.AVERAGE]: 'Average',
  DEFAULT: 'Below Average',
};

// Get score label based on score value
export const getScoreLabel = (score) => {
  if (score >= SCORE_THRESHOLDS.EXCEPTIONAL) return SCORE_LABELS[SCORE_THRESHOLDS.EXCEPTIONAL];
  if (score >= SCORE_THRESHOLDS.OUTSTANDING) return SCORE_LABELS[SCORE_THRESHOLDS.OUTSTANDING];
  if (score >= SCORE_THRESHOLDS.VERY_GOOD) return SCORE_LABELS[SCORE_THRESHOLDS.VERY_GOOD];
  if (score >= SCORE_THRESHOLDS.GOOD) return SCORE_LABELS[SCORE_THRESHOLDS.GOOD];
  if (score >= SCORE_THRESHOLDS.AVERAGE) return SCORE_LABELS[SCORE_THRESHOLDS.AVERAGE];
  return SCORE_LABELS.DEFAULT;
};

// Get score color class based on score value
export const getScoreColorClass = (score) => {
  if (score >= SCORE_THRESHOLDS.OUTSTANDING) return 'border-[#d4af37] text-[#d4af37]';
  if (score >= SCORE_THRESHOLDS.GOOD) return 'border-emerald-500 text-emerald-500';
  if (score >= SCORE_THRESHOLDS.AVERAGE) return 'border-amber-500 text-amber-500';
  return 'border-stone-500 text-stone-500';
};
